export default __webpack_public_path__ + "static/media/back.10b8e36c.svg";